const range = (n) => [...Array(n).keys()]

export default {
  keydownListener(e) {
    // console.log(`keydown`, e)
    switch (e.key) {
      case "PageUp":
      case "ArrowUp":
      case "ArrowLeft":
        this.previousPage()
        break;
      case "PageDown":
      case "ArrowDown":
      case "ArrowRight":
        // msg.preventDefault()
        // msg.stopPropagation
        // msg.stopImmediatePropagation()

        this.nextPage()
        break;
      case "Home":
        this.firstPage()
        break;
      case "End":
        this.lastPage()
    }
  },

  resizeListener() {
    this.pageCount = undefined
    this.setCount()
  },

  wheelListener(ev) {
    // console.error(`scroll wheel event:`, ev)
    if (this.pending == this.page()) {
      let direction;
      if (ev.deltaY > 0) {
        console.log(`scroll down`)
        this.nextPage()
      } else {
        console.log(`scroll up`)
        this.previousPage()
      }
    }
  },

  mounted() {
    console.log(`PageScroll: mounted`)
    this.pending = this.page()
    this.scrolling = false

    this.scrollPos = 0

    window.addEventListener("keydown", e => this.keydownListener(e))

    window.addEventListener("resize", () => this.resizeListener())

    window.addEventListener('wheel', e => this.wheelListener(e))
  },

  beforeUpdate() {
    // console.log(`beforeUpdate: el`, this.el)
    // console.log(`beforeUpdate:`, this.el.getBoundingClientRect())

    // this.setBounds()

    // console.log(`beforeUpdate:`, this.el.getBoundingClientRect())
    // const children = [...this.el.children]
    // const first = children.first()

    // this.lastBounds = {
    //   top: first.getBoundingClientRect().top,
    //   offset: this.el.getBoundingClientRect().top
    // }

    // console.log(`beforeUpdate: bounds`, this.lastBounds)
  },

  updated() {
    // console.log(`updated:`, this.el.getBoundingClientRect())
    // console.log(`pending: before: ${this.pending}`)
    this.pending = this.page()
    // console.log(`pending: after: ${this.pending}`)

    const children = [...this.el.children]

    if (this.pageCount === undefined) {
      this.pageCount = children.filter(c => !c.hasClass("row_spacer")).filter(c => !c.hasClass("sticky")).filter(c => c.isInViewport()).length
      this.pageCount = children.filter(c => c.isInViewport()).length
      console.log(`pageCount: ${this.pageCount}`)

      this.pushEvent('set-page-count', {
        // perPage: this.pageCount - 3
        perPage: this.pageCount - 2
      })
    }

    let count = parseInt(this.el.dataset.count)
    // console.log(`count: ${count}`)
    if (count > 1) {
      // console.log(`this.lastBounds`, this.lastBounds)
      // console.log(`bounding: before`, this.el.getBoundingClientRect())
      // this.setContainerHeight()

      // let spacer = [...this.el.getElementsByClassName("row_spacer")].first()
      // let offset
      // if (this.lastBounds.offset > 0) {
      //   offset = this.lastBounds.offset - this.lastBounds.top
      //   // offset = this.lastBounds.offset
      // } else {
      //   offset = (this.lastBounds.offset * -1) + this.lastBounds.top
      //   // offset = (this.lastBounds.offset * -1)
      // }
      // spacer.style.height = `${offset}px`


      // this.setOffset()
      // let heights = []

      // const first = children.first()
      // const last = children.slice(-1).first()

      const bounding = this.el.getBoundingClientRect()
      console.log(`bounding: after`, this.el.getBoundingClientRect())

      // children.forEach(c => heights.push(c.offsetHeight))

      // let avg = Math.ceil(heights.reduce((a, b) => a + b, 0) / heights.length)

      // this.el.style.height = `${avg  * count}px`

      // let spacer = [...this.el.getElementsByClassName("row_spacer")].first()
      // console.log(`spacer:`, spacer, spacer == undefined)
      // if (spacer != undefined) {
      //   let offset
      //   if (this.lastBounds.offset > 0) {
      //     offset = this.lastBounds.offset - this.lastBounds.top
      //   } else {
      //     offset = (this.lastBounds.offset * -1) + this.lastBounds.top
      //   }
      //   console.log(`offset: ${offset}`)
      //   spacer.style.height = `${offset}px`
      // }
      // this.setContainerHeight()
    } else {
      // console.log(`count < 1`)
    }
    // this.setBounds()
    this.scrolling = false

  },

  destroyed() {
    window.removeEventListener("keydown", () => this.keydownListener())
    window.removeEventListener("resize", () => this.resizeListener())
    window.removeEventListener('wheel', () => this.wheelListener())
  },

  page() {
    return parseInt(this.el.dataset.page)
  },

  totalPages() {
    return parseInt(this.el.dataset.pages)
  },

  count() {
    return parseInt(this.el.dataset.count)
  },

  previousPage() {
    if (this.pending == this.page() && this.page() > 1) {
      this.pending = this.page() - 1
      this.scrolling = true
      this.pushEvent('load-previous', {})
    } else {
      console.error(`ignoring previousPage`)
    }
  },

  nextPage() {
    if (this.pending == this.page() && this.pending < this.totalPages()) {
      this.pending = this.page() + 1
      this.pushEvent('load-next', {})
    } else {
      console.error(`ignoring nextPage: pending: ${this.pending} page: :${this.page()} total pages: ${this.totalPages()}`)
    }
  },

  firstPage() {
    this.pending = 1
    this.pushEvent('load-reset', {})
  },

  lastPage() {
    if (this.pending == this.page()) {
      this.pending = parseInt(this.el.dataset.pages)
      this.pushEvent('load-end', {})
    }
  },

  setCount() {
    // console.log(`scroll type: ${this.el.dataset.scrollType}`, this.el.dataset)
    if (this.el.dataset.scrollType === 'table') {
      return
    }
      const children = [...this.el.children]
      this.el.addClass('relative')

      const spacer = document.createElement("div")
      // spacer.style = 'height: 100vh; position: absolute; width: 2rem; background-color: orange; left: 0; top: 0;'
      spacer.style = 'height: 100vh; position: absolute; width: 0; left: 0; top: 0;'
      this.el.appendChild(spacer)
      const heights = []
      children.forEach(c => heights.push(c.offsetHeight))
      const avg = Math.ceil(heights.reduce((a, b) => a + b, 0) / heights.length)

      range(40).forEach(() => {
        const d = document.createElement("div")
        // d.style = `height: ${avg}px; width: 1rem; background-color: orange;`
        d.style = `height: ${avg}px; width: 0;`
        spacer.appendChild(d)
      })

      const visible = [... spacer.children].filter(c => c.isInViewport())
      // const top = visible.first().top
      // const bottom = visible.slice(-1).first().bottom
      // const height = bottom - top
      this.pageCount = visible.length

      this.pushEvent('set-page-count', {
        perPage: this.pageCount
      })
    }
}